import { useEffect } from "react";
import { Coordinate } from "ol/coordinate";
import { useMapContext } from "@avinet/adaptive-ui-maps/map/MapProvider";

interface MapMouseMoveListenerProps {
  onMouseMove: (coords: Coordinate) => void;
}

const MapMouseMoveListener = ({ onMouseMove }: MapMouseMoveListenerProps) => {
  const { map } = useMapContext();

  useEffect(() => {
    if (!map) return;
    const mapEl = map.getTargetElement();
    if (!mapEl) return;

    const handleMouseMove = (e: MouseEvent) => {
      const rect = mapEl.getBoundingClientRect();
      const x = e.clientX;
      const y = e.clientY;
      if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom)
        return;
      const viewX = x - rect.left;
      const viewY = y - rect.top;
      const coord = map.getCoordinateFromPixel([viewX, viewY]);
      onMouseMove(coord);
    };

    document.body.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.body.removeEventListener("mousemove", handleMouseMove);
    };
  }, [map, onMouseMove]);
  return null;
};

export default MapMouseMoveListener;
